import api from "./axiosConfig";
import { Client } from "../types";

export type CreateClientRequest = Omit<Client, "id" | "tenantId">;
export type UpdateClientRequest = Omit<Client, "id" | "tenantId" | "createdAt">;

export const clientsApi = {
  getAll: async (): Promise<Client[]> => {
    const response = await api.get<Client[]>("/clients");
    return response.data;
  },

  getById: async (id: string): Promise<Client> => {
    const response = await api.get<Client>(`/clients/${id}`);
    return response.data;
  },

  create: async (payload: CreateClientRequest): Promise<Client> => {
    const response = await api.post<Client>("/clients", payload);
    return response.data;
  },

  update: async (id: string, payload: UpdateClientRequest): Promise<Client> => {
    const response = await api.put<Client>(`/clients/${id}`, payload);
    return response.data;
  },

  /** Soft-delete a client (DELETE /clients/{id}). Backend flips IsActive=false + sets DeletedAt. */
  archive: async (id: string): Promise<void> => {
    await api.delete(`/clients/${id}`);
  },

  /** Restore an archived client (POST /clients/{id}/restore). Platform-owner only. */
  restore: async (id: string): Promise<Client> => {
    const response = await api.post<Client>(`/clients/${id}/restore`);
    return response.data;
  },

  /** List archived clients for the current tenant (GET /clients/archived). Platform-owner only. */
  getArchived: async (): Promise<Client[]> => {
    const response = await api.get<Client[]>("/clients/archived");
    return response.data;
  },
};
